import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import createMuiTheme, {
    ThemeOptions
} from "@material-ui/core/styles/createMuiTheme";
import React from "react";

declare module "@material-ui/core/styles/createMuiTheme" {
    //custom theme options typings
    interface Theme extends ThemeOptions {}
    interface ThemeOptions {}
}

function createAppTheme(options: ThemeOptions) {
    const theme = createMuiTheme({
        typography: {
            ...({
                useNextVariants: true
            } as any)
        }
    });
    return createMuiTheme({
        typography: {
            ...({
                useNextVariants: true
            } as any),
            fontFamily: "Roboto, Helvetica, Arial, sans-serif"
        },

        palette: {
            primary: {
                main: "#43425d",
                contrastText: "#fff"
            },
            secondary: {
                main: "#896eb1",
                contrastText: "#fff"
            },
            success: {
                main: "#6eb072"
            },
            error: {
                main: "#f65c5c"
            },
            text: {
                primary: "#4D4F5C",
                secondary: "#a1a0ae"
            },
            background: {
                default: "#fff",
                paper: "#fff"
            },
            common: {
                black: "#000",
                white: "#fff"
            },
            grey: {
                "200": "#f5f6fa",
                "300": "#f2f2f2",
                "400": "#e4e4e4",
                "600": "#b9babf",
                "700": "#afafaf"
            }
        },

        zIndex: {},
        overrides: {
            MuiInputBase: {
                root: {
                    minHeight: 40
                }
            }
        },
        ...options
    });
}

const theme = createAppTheme({});

export default theme;
